import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "./AuthContext";

const AutoLogout = () => {
  const { auth, logout } = useAuth();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const checkTokenExpiration = () => {
      const storedToken = localStorage.getItem("jwttoken");

      if (!auth.isAuthenticated || !storedToken) return;

      try {
        const decoded = jwtDecode(storedToken);
        const currentTime = Date.now() / 1000;

        if (decoded.exp && decoded.exp < currentTime) {
          setShowModal(true);
        }
      } catch (error) {
        console.error("JWT Decode Error:", error);
        logout();
      }
    };

    const interval = setInterval(checkTokenExpiration, 5000);
    return () => clearInterval(interval);
  }, [auth.isAuthenticated, logout]);

  const handleLogin = () => {
    localStorage.clear();
    logout();
    window.location.href = "/login"; 
  };

  return (
    <>
      {showModal && (
        <div 
          className="modal" 
          style={{ 
            display: 'block',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1050
          }}
          onClick={handleLogin}
        >
          <div 
            className="modal-dialog modal-dialog-centered"
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Session Expired</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={handleLogin}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>Your session has expired. Please log in again.</p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={handleLogin}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AutoLogout;
